import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import Loader from "@babackapp/ui/components/loader";
import { cn } from "@babackapp/ui/lib/utils";
import { useFormContext } from "react-hook-form";

export default function FormSaveButton() {
  const t = useTranslation();

  const { formState } = useFormContext();
  const isLoading =
    formState.isSubmitting || formState.isLoading || formState.isSubmitting;
  const isDirty = formState.isDirty;

  const enabled = !isLoading && isDirty;

  return (
    <div
      className={cn(
        "flex justify-center items-center pointer-events-auto",
        !enabled && "pointer-events-none",
      )}
    >
      <div>
        <Button
          type="submit"
          className="flex justify-evenly"
          disabled={!enabled}
        >
          <div
            className={cn(
              "overflow-hidden transition-all duration-500 ease-in-out",
              isLoading ? "w-4 opacity-100 mr-2" : "w-0 opacity-0 mr-0",
            )}
          >
            <Loader className="h-4 w-4 text-primary-foreground animate-spin" />
          </div>
          {t("misc.save")}
        </Button>
      </div>
    </div>
  );
}
